export default __webpack_public_path__ + "static/media/campagna-astronaut.db3d57ea.png";